export default __webpack_public_path__ + "assets/images/0e9c9b5de898783f88d60ed631207d2a.png";